import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import OrderPrintView from '../../views/OrderPrintView';

import tmplOrderPrintPage from './OrderPrintPage.hbs';
import './OrderPrintPage.css';

const OrderPrintPage = View.extend({
  template: tmplOrderPrintPage,

  className: 'order-print-view',

  ui: {
    printPage: '.print-page',
    generalView: '.general-view',
    deliveryScheduleView: '.delivery-schedule-view',
    orderSummaryView: '.order-summary-view2',
    informationView: '.information-view',
    deviceView: '.device-view'
  },

  regions: {
    printPage: '@ui.printPage',
    generalView: '@ui.generalView',
    deliveryScheduleView: '@ui.deliveryScheduleView',
    orderSummaryView: '@ui.orderSummaryView',
    informationView: '@ui.informationView',
    deviceView: '@ui.deviceView'
  },

  templateContext() {
    return {
      isUserInternal: !EXTERNAL,
      status: EXTERNAL
        ? this.model.get('extOrderDetails').externalOrderStatus
        : this.model.get('extOrderDetails').internalOrderStatus
    };
  },

  onRender() {
    const isRelocation = this.model.get('isRelocation');
    const isSpecialtyRequirement = this.model.get('isSpecialtyRequirement');

    if (isRelocation) {
      this.showChildView(
        'printPage',
        new OrderPrintView({
          model: new Backbone.Model({
            allLineItems: this.model.get('allLineItems'),
            orderDetails: this.model.get('orderDetails'),
            extOrderDetails: this.model.get('extOrderDetails'),
            internalPOCs: this.model.get('internalPOCs'),
            order: this.model.get('order'),
            deliverySchedules: this.model.get('formattedSchedules')
          })
        })
      );
    } else {
      const generalView = this.model.get('generalView');
      const deliveryView = this.model.get('deliveryView');
      const orderSummaryView = this.model.get('orderSummaryView');
      const informationView = this.model.get('informationView');
      this.$('.device-text').removeClass('d-inline');
      this.$('.device-text').hide();
      this.$('.device').remove();

      if (isSpecialtyRequirement) {
        this.$('.general-text').removeClass('d-inline');
        this.$('.general-text').hide();
        this.$('.general').remove();
        this.$('.general page-break').remove();
      } else {
        this.showChildView('generalView', generalView);
      }

      this.showChildView('deliveryScheduleView', deliveryView);
      if (!EXTERNAL) {
        this.showChildView('informationView', informationView);
      }
      this.showChildView('orderSummaryView', orderSummaryView);
    }
    //change text areas into divs so that all text is visible
    this.$('textarea').each(function () {
      const textareaContent = $(this).val();
      $(this).replaceWith(`<div class="overflow-text">${textareaContent}</div>`);
    });
  },

  onAttach() {
    const showPrintWindow = this.model.get('showPrintWindow');
    if (showPrintWindow) {
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  }
});

export default OrderPrintPage;
